import React, { useEffect, useRef, useState } from "react";
import pogImage from "../../../../assets/casino/pog.png";
import { formatPogs } from "./rouletteConstants";
import { getRouletteNumberAsset } from "./rouletteNumberAssets";

function getRouletteWagerOdds(type) {
  switch (type) {
    case "straight":
      return "37/1";
    case "trio":
      return "35/3";
    case "corner":
      return "17/2";
    case "dozen":
    case "column":
      return "2/1";
    case "colour":
    case "parity":
    case "range":
      return "1/1";
    default:
      return null;
  }
}

function getRouletteStakeUnit(type) {
  if (type === "trio") return 3;
  if (type === "corner") return 2;
  return 1;
}

function BetAmountModal({ region, availableBalance, onConfirm, onClose }) {
  const [amount, setAmount] = useState("");
  const inputRef = useRef(null);

  const visualBetNumbers = (() => {
    if (region?.type === "straight") {
      return [String(region.selection)];
    }

    if (region?.type === "trio" || region?.type === "corner") {
      return String(region.selection || "")
        .split("_")
        .filter(Boolean);
    }

    return [];
  })();

  const numberAssets = visualBetNumbers
    .map((value) => ({
      value,
      src: getRouletteNumberAsset(value),
    }))
    .filter((item) => item.src);

  const useNumberAssets =
    numberAssets.length > 0 &&
    numberAssets.length === visualBetNumbers.length;

  const wagerOdds = getRouletteWagerOdds(region?.type);
  const stakeUnit = getRouletteStakeUnit(region?.type);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    onConfirm(amount);
  };

  return (
    <div className="casino-modal-layer casino-modal-layer-nested" role="presentation">
      <div
        className="casino-amount-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="casino-amount-title"
      >
        <div className="casino-amount-available">
          <span className="casino-amount-available-label">
            AVAILABLE POGS
          </span>
          <span className="casino-amount-available-value">
            {Number(availableBalance) !== 0 && (
              <img
                className="casino-amount-available-pog-icon"
                src={pogImage}
                alt=""
                aria-hidden="true"
                draggable="false"
              />
            )}
            <strong>{formatPogs(availableBalance)}</strong>
          </span>
        </div>

        <p
          id="casino-amount-title"
          className="casino-modal-kicker casino-amount-wager-kicker"
        >
          ROULETTE WAGER
        </p>

        <div className="casino-amount-wager-display">
          {useNumberAssets ? (
            <div
              className={[
                "casino-amount-number-assets",
                `casino-amount-number-assets-${numberAssets.length}`,
              ].join(" ")}
              aria-label={region?.label || region?.selection}
            >
              {numberAssets.map((item) => (
                <img
                  key={item.value}
                  className="casino-amount-number-asset"
                  src={item.src}
                  alt={item.value}
                  draggable="false"
                />
              ))}
            </div>
          ) : (
            <p className="casino-amount-selection">
              {region?.label || region?.selection}
            </p>
          )}
        </div>

        {wagerOdds && (
          <p className="casino-amount-odds">
            at <strong>{wagerOdds}</strong>
          </p>
        )}

        <form onSubmit={handleSubmit}>
          <label
            className="casino-amount-to-bet-label"
            htmlFor="casino-amount-input"
          >
            AMOUNT TO BET:
          </label>

          <input
            id="casino-amount-input"
            ref={inputRef}
            className="casino-amount-input"
            type="number"
            inputMode="numeric"
            min={stakeUnit}
            step={stakeUnit}
            value={amount}
            onChange={(event) => setAmount(event.target.value)}
            aria-label="Bet amount in Pogs"
          />

          <div className="casino-amount-actions">
            <button type="submit" className="casino-button">
              CONFIRM
            </button>
            <button type="button" className="casino-button casino-button-secondary" onClick={onClose}>
              BACK
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default BetAmountModal;
